var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lamp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M12.969,7.922A1.719,1.719,0,0,1,11.25,6.2V1.719a1.719,1.719,0,1,1,3.437,0V6.2A1.719,1.719,0,0,1,12.969,7.922Z",
    transform: "translate(14.531)",
    fill: "#aab83e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M19.539,9.905A1.72,1.72,0,0,1,18.325,6.97L21.5,3.8a1.719,1.719,0,0,1,2.431,2.431L20.756,9.4A1.724,1.724,0,0,1,19.539,9.905Z",
    transform: "translate(23.019 4.255)",
    fill: "#aab83e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M26.747,14.687H22.262a1.719,1.719,0,0,1,0-3.437h4.485a1.719,1.719,0,1,1,0,3.437Z",
    transform: "translate(26.535 14.531)",
    fill: "#aab83e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M22.711,24.431a1.705,1.705,0,0,1-1.215-.5l-3.172-3.172a1.719,1.719,0,0,1,2.431-2.431L23.928,21.5a1.72,1.72,0,0,1-1.217,2.936Z",
    transform: "translate(23.019 23.018)",
    fill: "#aab83e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M5.013,24.431A1.72,1.72,0,0,1,3.8,21.5l3.172-3.172A1.719,1.719,0,0,1,9.4,20.755L6.23,23.927A1.714,1.714,0,0,1,5.013,24.431Z",
    transform: "translate(4.256 23.018)",
    fill: "#aab83e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M6.2,14.687H1.719a1.719,1.719,0,1,1,0-3.437H6.2a1.719,1.719,0,1,1,0,3.437Z",
    transform: "translate(0 14.531)",
    fill: "#aab83e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M8.185,9.905a1.705,1.705,0,0,1-1.215-.5L3.8,6.229A1.719,1.719,0,0,1,6.23,3.8L9.4,6.97A1.72,1.72,0,0,1,8.185,9.905Z",
    transform: "translate(4.256 4.255)",
    fill: "#aab83e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M22.75,21v2.865a4.03,4.03,0,0,1-4.01,4.01H13.01C11.085,27.875,9,26.408,9,23.2V21Z",
    transform: "translate(11.625 27.125)",
    fill: "#aab83e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M31.15,8.573A16.043,16.043,0,1,0,11.4,33.85a6.92,6.92,0,0,1,2.613,4.377v.023a.39.39,0,0,1,.16-.023h13.75a.207.207,0,0,1,.115.023v-.023a7.644,7.644,0,0,1,2.933-4.583A16.051,16.051,0,0,0,31.15,8.573ZM29.637,22.186a1.731,1.731,0,0,1-1.719-1.719,6.3,6.3,0,0,0-6.3-6.3,1.719,1.719,0,1,1,0-3.437,9.761,9.761,0,0,1,9.74,9.74A1.731,1.731,0,0,1,29.637,22.186Z",
    transform: "translate(6.457 6.46)",
    fill: "#aab83e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M8.93,19.5h.16a.39.39,0,0,0-.16.023Z",
    transform: "translate(11.535 25.188)",
    fill: "#aab83e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M15.115,19.5v.023A.207.207,0,0,0,15,19.5Z",
    transform: "translate(19.375 25.188)",
    fill: "#aab83e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.7091b199af7218af837ce53d03e4c414.svg";
export { ForwardRef as ReactComponent };